module.exports = __webpack_public_path__ + "img/whatsapp.6a82c335.svg";